<template>
    <div id="featureCardRoot">
        <div @mouseover="visibility = true" @touchstart="visibility = true"
             @mouseleave="visibility = false"  @touchend="visibility = false" id="featureContainer">
            <img id="title" src="../assets/julio-text.svg"/>

            <div id="featureTitle">
                <span>Beta 4.1</span>
            </div>

            <div id="readMore">
                <span>Read more</span>
            </div>
        </div>
        <JulioIcon :show="visibility" id="icon"/>
        <JulioBottomNavigationLine :show="visibility" id="background"/>
    </div>

</template>

<script>
	import JulioBottomNavigationLine from "./icons/JulioBottomNavigationLine";
	import JulioIcon from "./icons/JulioIcon";

	export default {
		name: "FeaturedCard",
		components: {JulioIcon, JulioBottomNavigationLine},
		data() {
			return {
				animationState: false
			}
		},
		computed: {
			visibility: {
				set: function (newValue) {
					this.animationState = newValue;
				},
				get: function () {
					return this.animationState
				}
			}
		}
	}
</script>

<style lang="scss" src="../styles/featurecard.scss" scoped/>